import type { LedgerAccount } from '../types/incoming-invoices.types'

/** „5000 Wareneinsatz" — die Nummer allein, wenn der Stamm sie nicht kennt. */
export function kontoText(konten: readonly LedgerAccount[], nummer: string | null | undefined): string {
  if (!nummer) return ''
  const k = konten.find((x) => x.number === nummer)
  return k ? `${k.number} ${k.name}` : nummer
}

/**
 * Die Einträge einer Sachkonto-Auswahl (Kopf, Position): die aktiven Konten des Stamms. Ein Konto, das schon
 * dasteht, bleibt wählbar, auch wenn es abgeschaltet ist oder im Stamm fehlt (vorgeschlagen aus Artikel,
 * Kategorie oder Lieferant) — sonst zeigte die Auswahl etwas anderes, als gespeichert ist.
 */
export function KontoOptionen({ konten, aktuell }: { konten: readonly LedgerAccount[]; aktuell: string | null | undefined }) {
  const bekannt = konten.find((k) => k.number === aktuell)
  return (
    <>
      {aktuell && !bekannt?.isActive && <option value={aktuell}>{bekannt ? `${bekannt.number} ${bekannt.name} (abgeschaltet)` : `${aktuell} (nicht im Stamm)`}</option>}
      {konten
        .filter((k) => k.isActive)
        .map((k) => (
          <option key={k.number} value={k.number}>
            {`${k.number} ${k.name}`}
          </option>
        ))}
    </>
  )
}
